// @ts-check

/** @typedef {import('@/services/api/schema').components['schemas']['PhoneBookDirectoryEntry']} PhoneBookDirectoryEntry */

/**
 * Directory key of a contact, matching the backend's `contact-<entry id>`.
 * @param {number} entryId
 * @returns {string}
 */
export function contactKey(entryId) {
  return `contact-${entryId}`
}

/**
 * Twilio connect params for dialing a directory entry: contacts go by phone_book_entry_id,
 * internal users by their number.
 * @param {PhoneBookDirectoryEntry} entry
 * @returns {{ phoneBookEntry: { id: number, name: string, phone_number: string } } | { toPhoneNumber: string, contactLabel: string }}
 */
export function directoryDialTarget(entry) {
  if (entry.type === 'contact') {
    return { phoneBookEntry: { id: /** @type {number} */ (entry.phone_book_entry_id), name: entry.name, phone_number: entry.phone_number } }
  }
  return { toPhoneNumber: entry.phone_number, contactLabel: entry.name }
}

/**
 * (555) 123-4567 for US numbers; anything else unchanged.
 * @param {string} phone
 * @returns {string}
 */
export function formatPhone(phone) {
  const digits = (phone || '').replace(/\D/g, '')
  const local = digits.length === 11 && digits[0] === '1' ? digits.slice(1) : digits
  return local.length === 10 ? `(${local.slice(0, 3)}) ${local.slice(3, 6)}-${local.slice(6)}` : phone
}
